import { NUMBER } from "../../constants/app-constants";
const fileFormats = [ "png", "jpeg", "pdf" ];

export const convertMbToBytes = (size) => {
    return  size * NUMBER.ONE_THOUSAND_TWENTY_FOUR * NUMBER.THOUSAND;
};

export const isInvalidFileSize = (uploadedPhoto, maxLimit = NUMBER.TEN) => {
    const maxAllowedSize = convertMbToBytes(maxLimit);
    if (!maxAllowedSize) return true;
    return uploadedPhoto && uploadedPhoto.size > maxAllowedSize;
};

export const isInvalidFileFormat = (uploadedPhoto, validFileFormats = fileFormats) => {
    return uploadedPhoto && uploadedPhoto.type && !(validFileFormats.some(elem => uploadedPhoto.type.includes(elem)));
};
